import { Image } from '@components';
import { Box } from '@mui/material';

type ProductListItemProps = {
  displayName: string;
  imageUrl: string;
  url: string;
};

export const ProductListItem: React.FC<ProductListItemProps> = ({
  displayName,
  imageUrl,
  url,
}: ProductListItemProps) => {
  const handleNavigation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  };

  return (
    <Box onClick={handleNavigation} sx={{ width: 'fit-content' }}>
      <Box
        display='flex'
        gap={2}
        alignItems='center'
        sx={{
          '& img': {
            height: '50px',
            width: '50px',
          },
        }}
      >
        <Image
          image={imageUrl}
          resizerParams={{ width: 50, format: 'webp' }}
          imgClassName='product-image'
          width='50'
          height='50'
        />
        <div className='link primary'>{displayName}</div>
      </Box>
    </Box>
  );
};
